<div class="add-variants">
  <div class="steps">
    <button type="button" [class.active]="step === 'styles'" (click)="backToStyles()">
      <span>1</span>
      {{ 'Choose style' | locale }}
    </button>
    <button type="button" [class.active]="step === 'variants'" [disabled]="!activeParent">
      <span>2</span>
      {{ 'Enter quantities' | locale }}
    </button>
  </div>

  <ng-container *ngIf="step === 'styles'; else variantsStep">
    <nz-alert
      *ngIf="settingsErrors.length > 0"
      nzType="error"
      [nzMessage]="'Add Variants settings are not complete' | locale"
      [nzDescription]="settingsErrorList"
      nzShowIcon>
    </nz-alert>
    <ng-template #settingsErrorList>
      <div *ngFor="let message of settingsErrors">{{ message }}</div>
    </ng-template>

    <div class="search-panel">
      <nz-input-group nzPrefixIcon="search">
        <input
          nz-input
          [placeholder]="'Search item, variant, color, size, brand, barcode' | locale"
          [(ngModel)]="search"
          (ngModelChange)="onSearch($event)"
        />
      </nz-input-group>

      <div class="filters">
        <nz-select
          *ngFor="let filter of runtimeFilters; trackBy: trackFilter"
          nzMode="multiple"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="filter.label | locale"
          [(ngModel)]="filters[filter.key]"
          (ngModelChange)="applyFilters()">
          <nz-option
            *ngFor="let option of filter.options"
            [nzValue]="option.value"
            [nzLabel]="option.label">
          </nz-option>
        </nz-select>
        <button nz-button nzType="default" (click)="applyFilters()">
          <i nz-icon nzType="filter" nzTheme="outline"></i>
        </button>
      </div>
    </div>

    <nz-alert *ngIf="error" nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>

    <nz-spin [nzSpinning]="loading || settingsLoading">
      <nz-empty *ngIf="!loading && items.length === 0" [nzNotFoundContent]="'No styles found' | locale"></nz-empty>

      <div class="style-grid">
        <button class="style-card" type="button" *ngFor="let item of items; trackBy: trackParent" (click)="chooseStyle(item)">
          <div class="image">
            <img *ngIf="item.imageUrl" [src]="item.imageUrl | productImageUrl" />
            <i *ngIf="!item.imageUrl" nz-icon nzType="appstore" nzTheme="outline"></i>
          </div>
          <div class="style-body">
            <strong>{{ item.parentItemCode }}</strong>
            <span>{{ item.parentItemName }}</span>
            <div class="meta">
              <nz-tag *ngIf="item.brand">{{ item.brand }}</nz-tag>
              <nz-tag *ngIf="item.productGroup">{{ item.productGroup }}</nz-tag>
              <nz-tag *ngIf="item.collection">{{ item.collection }}</nz-tag>
            </div>
          </div>
          <div class="style-action">
            <span>{{ variantCount(item) }} {{ 'variants' | locale }}</span>
            <i nz-icon nzType="right" nzTheme="outline"></i>
          </div>
        </button>
      </div>
    </nz-spin>

    <div class="pager" *ngIf="totalCount > pageSize">
      <nz-pagination
        [nzPageIndex]="page"
        [nzPageSize]="pageSize"
        [nzTotal]="totalCount"
        (nzPageIndexChange)="pageChanged($event)">
      </nz-pagination>
    </div>
  </ng-container>

  <ng-template #variantsStep>
    <nz-alert *ngIf="error" nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>

    <nz-spin [nzSpinning]="loading">
      <section class="detail" *ngIf="activeParent">
        <div class="detail-header">
          <button nz-button nzType="default" (click)="backToStyles()">
            <i nz-icon nzType="left" nzTheme="outline"></i>
            {{ 'Back' | locale }}
          </button>
          <div class="image">
            <img *ngIf="activeParent.imageUrl" [src]="activeParent.imageUrl | productImageUrl" />
            <i *ngIf="!activeParent.imageUrl" nz-icon nzType="appstore" nzTheme="outline"></i>
          </div>
          <div class="title">
            <strong>{{ activeParent.parentItemCode }}</strong>
            <span>{{ activeParent.parentItemName }}</span>
            <div class="meta">
              <nz-tag *ngIf="activeParent.brand">{{ activeParent.brand }}</nz-tag>
              <nz-tag *ngIf="activeParent.productGroup">{{ activeParent.productGroup }}</nz-tag>
              <nz-tag *ngIf="activeParent.collection">{{ activeParent.collection }}</nz-tag>
            </div>
          </div>
        </div>

        <div class="variant-area">
          <div class="matrix" *ngIf="canUseMatrix(activeParent); else variantList">
            <div class="matrix-row matrix-head">
              <div>{{ 'Color' | locale }}</div>
              <div *ngFor="let size of sizes(activeParent)">{{ size }}</div>
            </div>
            <div class="matrix-row" *ngFor="let color of colors(activeParent)">
              <div class="color-label">{{ color }}</div>
              <div *ngFor="let size of sizes(activeParent)">
                <ng-container *ngIf="variantAt(activeParent, color, size) as variant">
                  <input
                    nz-input
                    type="number"
                    min="0"
                    [ngModel]="quantities[variant.itemCode]"
                    (ngModelChange)="setQuantity(variant, $event)"
                    [title]="variant.itemCode"
                  />
                </ng-container>
              </div>
            </div>
          </div>

          <ng-template #variantList>
            <div class="variant-list">
              <div class="variant-row" *ngFor="let variant of activeParent.variants; trackBy: trackVariant">
                <div>
                  <strong>{{ variant.itemCode }}</strong>
                  <span>{{ variant.itemName }}</span>
                  <small>
                    <ng-container *ngFor="let field of variantDetailFields()">
                      <span *ngIf="variantFieldValue(variant, field)">
                        {{ field.label }}: {{ variantFieldValue(variant, field) }}
                      </span>
                    </ng-container>
                  </small>
                </div>
                <div class="price" *ngIf="variant.price != null">{{ variant.price | amount }} {{ variant.currency }}</div>
                <input
                  nz-input
                  type="number"
                  min="0"
                  [ngModel]="quantities[variant.itemCode]"
                  (ngModelChange)="setQuantity(variant, $event)"
                />
              </div>
            </div>
          </ng-template>
        </div>
      </section>
    </nz-spin>
  </ng-template>

  <div class="footer">
    <div>
      <strong>{{ selectedCount() }}</strong> {{ 'variants' | locale }}
      <span>{{ totalQuantity() }} {{ 'total qty' | locale }}</span>
    </div>
    <div>
      <button nz-button (click)="cancel()">{{ 'Cancel' | locale }}</button>
      <button nz-button nzType="primary" [disabled]="selectedCount() === 0" (click)="confirm()">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        {{ 'Add selected variants' | locale }}
      </button>
    </div>
  </div>
</div>
